import { render, staticRenderFns } from "./SearchOrAddSubstance.vue?vue&type=template&id=39329bf7&scoped=true&"
import script from "./SearchOrAddSubstance.vue?vue&type=script&lang=js&"
export * from "./SearchOrAddSubstance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39329bf7",
  null
  
)

export default component.exports